import { fc } from "@chatbotgang/etude/react/fc";
import ClearIcon from "@mui/icons-material/Clear";
import type { ChipProps } from "@mui/material/Chip";
import Chip from "@mui/material/Chip";

export const Tag = fc<ChipProps>(function Tag(props) {
  return <Chip deleteIcon={props.deleteIcon ?? <ClearIcon />} {...props} />;
});
